import { styled } from '@mui/material/styles'

/* eslint-disable no-undef, no-unused-vars, no-empty-pattern */

export const Main = styled('main')(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  display: 'flex',
  width: 'var(--viewportWidth)',
  height: '100%',
  minHeight: 'calc(100vh - 12rem)',
}))

export const Logo = styled('img')(() => ({
  marginBottom: '3rem',
  height: 'clamp(3rem, 8vw, 6rem)',
}))

/* eslint-enable no-undef, no-unused-vars, no-empty-pattern */
